import { writable } from 'svelte/store';

export const tenantLogado = writable(JSON.parse(localStorage.getItem('tenant') || 'null'));
export const baseUrl = writable(localStorage.getItem('baseUrl') || null);

tenantLogado.subscribe(val => {
  if (val) localStorage.setItem('tenant', JSON.stringify(val));
  else localStorage.removeItem('tenant');
});

baseUrl.subscribe(val => {
  if (val) localStorage.setItem('baseUrl', val);
  else localStorage.removeItem('baseUrl');
});
